import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileName'
})
export class FileNamePipe implements PipeTransform {

  transform(value: string): string {
    // Example: Extract filename from URL
    return (value) ? value.split('/').pop() || value : value;
  }

}
